import { render } from "./MdDivider.vue?vue&type=template&id=709a7832"
import script from "./MdDivider.vue?vue&type=script&lang=js"
export * from "./MdDivider.vue?vue&type=script&lang=js"

import "./MdDivider.vue?vue&type=style&index=0&id=709a7832&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__